import {
  descriptionToString,
  type TaggedResourceTiles,
} from "../../../utils/contentful-helpers";

interface ResourceTileFilters {
  subfields?: string[];
  degrees?: string[];
}

export const filterResourceTileGroupsByTag = (
  groups: TaggedResourceTiles[],
  filters: ResourceTileFilters,
): TaggedResourceTiles[] => {
  const activeFilters = [filters.subfields ?? [], filters.degrees ?? []].filter(
    (filterGroup) => filterGroup.length > 0,
  );

  if (activeFilters.length === 0) {
    return groups;
  }

  return groups.map((group) => ({
    ...group,
    data: group.data.filter((tile) => {
      const keywords = tile.data.keyword ?? [];

      return activeFilters.every((filterGroup) =>
        filterGroup.some((filterValue) => keywords.includes(filterValue)),
      );
    }),
  }));
};

export const filterResourceTileGroupsByQuery = (
  groups: TaggedResourceTiles[],
  query: string,
): TaggedResourceTiles[] => {
  const norm = (a: string) => a.trim().toLowerCase();

  return groups.map((group) => {
    return {
      ...group,
      data: group.data.filter(
        (tile) =>
          norm(tile.title).includes(norm(query)) ||
          norm(descriptionToString(tile.description)).includes(norm(query)),
      ),
    };
  });
};
